import { LinkUtils } from "@core/layout/utils/link.utils";
import { AngularRoutesEnum, DojoRoutesEnum, NavigationBase } from "@core/layout/enums/layout-routes.enum";
import { SideNavItem } from "@core/layout/components/side-nav/models/side-nav-item.model";
import { SideNavIds } from "@core/layout/components/side-nav/enums/side-nav-ids.enum";

export const SIDE_NAV_ADMIN_HOTLINE_ITEMS: SideNavItem[] = [
	{
		id: SideNavIds.ACCUEIL,
		icon: "home-alt",
		label: "Accueil",
		link: LinkUtils.generateLinkModel(NavigationBase.DOJO, DojoRoutesEnum.DASHBOARD),
	},
	{
		id: SideNavIds.DASHBOARD_ADMIN_HOTLINE,
		icon: "ordo",
		label: "Tdb admin",
		link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [DojoRoutesEnum.ADMIN_HOTLINE, DojoRoutesEnum.TDB]),
	},
	{
		id: SideNavIds.CLIENTS,
		icon: "users-alt",
		label: "Clients",
		link: null,
		enfants: [
			{
				id: SideNavIds.CLIENTS_LISTE_CLIENTS,
				icon: null,
				label: "Liste des clients",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.ADMIN_HOTLINE,
					DojoRoutesEnum.LISTE_CLIENTS,
				]),
			},
			{
				id: SideNavIds.CLIENTS_LISTE_CABINETS,
				icon: null,
				label: "Liste des cabinets",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.ADMIN_HOTLINE,
					DojoRoutesEnum.LISTE_CABINETS,
				]),
			},
			{
				id: SideNavIds.CLIENTS_ADMIN_GP,
				icon: null,
				label: "Admin GP",
				link: LinkUtils.generateLinkModel(NavigationBase.ANGULAR, [
					AngularRoutesEnum.ADMIN,
					AngularRoutesEnum.ADMIN_GP,
				]),
			},
		],
	},
	{
		id: SideNavIds.ANNUAIRES,
		icon: "receipt-alt",
		label: "Annuaires",
		link: null,
		enfants: [
			{
				id: SideNavIds.ANNUAIRES_MUTUELLES,
				icon: null,
				label: "Mutuelles",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.ANNUAIRE,
					DojoRoutesEnum.MUTUELLES,
				]),
			},
		],
	},
	{
		id: SideNavIds.MAJ_CBALINK,
		icon: "setting",
		label: "Maj CBALink",
		link: null,
		enfants: [
			{
				id: SideNavIds.MAJ_CBALINK_LISTE_MAJ,
				icon: null,
				label: "Liste des MAJ",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.ADMIN_HOTLINE,
					DojoRoutesEnum.MAJ_CBALINK,
				]),
			},
			{
				id: SideNavIds.MAJ_CBALINK_CREATION_MAJ,
				icon: null,
				label: "Création d'une MAJ",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.ADMIN_HOTLINE,
					DojoRoutesEnum.CREATION_MAJ,
				]),
			},
		],
	},
];
